import { HtmlRenderDictionary } from '@capgroup-cxt/aem-react-utils/lib/hooks/htmlParser/interfaces';
import { renderH2Paragraph } from 'utils/AemRenderMap/renderParagraph';

export const renderMap: HtmlRenderDictionary = {
    p: renderH2Paragraph,
};
